/**
 * If `raw` parses as a JSON object or array, return 2-space indented JSON.
 * Otherwise return `raw` unchanged (HTML, plain text, truncated fragments, etc.).
 */
export function prettifyJsonString(raw: string | null | undefined): string {
  if (raw == null) return '';
  const t = raw.trim();
  if (!t) return raw;
  try {
    const parsed: unknown = JSON.parse(t);
    if (parsed !== null && typeof parsed === 'object') {
      return JSON.stringify(parsed, null, 2);
    }
  } catch {
    /* not JSON object/array */
  }
  return raw;
}

/** Pretty JSON for inspector / lists: objects use `JSON.stringify`; strings try JSON minify→prettify. */
export function formatUnknownJsonForDisplay(payload: unknown): string {
  if (payload === null || payload === undefined) return String(payload);
  if (typeof payload === 'string') return prettifyJsonString(payload);
  try {
    return JSON.stringify(payload, null, 2);
  } catch {
    return String(payload);
  }
}
